import { Pipe, PipeTransform } from '@angular/core';
import { StorageService } from '../../../services/storage/storage.service';

/**
 enabled based on userData 'opacOptions.searchResultOptions.enableSearchHightlight'
 */
@Pipe({
  name: 'highlightsSearchTerm',
  standalone: false,
})
export class HighlightsSearchTermPipe implements PipeTransform {
  constructor(private storageService: StorageService) {}
  transform(value: any, args: any): any {
    if (
      !this.storageService.getUserData()?.opacOptions?.searchResultOptions?.enableSearchHightlight
    ) {
      return value;
    }

    if (value && args) {
      // eslint-disable-next-line
      let pattern = args.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern
        .split(' ')
        .filter((t) => {
          return t.length > 0;
        })
        .join('|');
      const re = new RegExp('(?:\\b)(' + pattern + ')(?:\\b)', 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
      return value.replace(re, (match) => {
        return `<span class="highlightText">${match}</span>`;
      });
    } else {
      return value;
    }
  }
}

@Pipe({
  name: 'encapsulateSpan',
  standalone: false,
})
export class EncapsulateSpanPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (value && args) {
      const pattern = args
        .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') // eslint-disable-line
        .split(' ')
        .filter((t) => {
          return t.length > 0;
        })
        .join('|');
      const regEx = new RegExp(`\\${pattern}`, 'gi');
      return value.replace(regEx, (match) => {
        return `<span>${match}</span>`;
      });
    } else {
      return value;
    }
  }
}
